import { Box, ButtonBase } from '@mui/material';

import { useExportSettings } from '@/features/DataHub/modules/Export/context/ExportSettingsContext';

const ImageFormatSelection = () => {
  const { exportSettings, updateExportSetting } = useExportSettings();
  const onClick = (type: string) => {
    updateExportSetting('exportSubType', type);
  };
  const buttons = [
    { label: 'PNG', type: 'image/png' },
    { label: 'PDF', type: 'application/pdf' },
    { label: 'JPEG', type: 'image/jpeg' },
    { label: 'SVG', type: 'image/svg+xml' }
  ];
  return (
    <Box
      sx={{
        maxHeight: 150,
        fontSize: 16,
        fontWeight: 600,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        flexWrap: 'wrap'
      }}
    >
      {buttons.map(({ label, type }) => (
        <Box
          key={label}
          sx={{ mt: 1 }}
        >
          <ButtonBase
            sx={{
              border: '1px solid',
              borderColor: exportSettings.exportSubType === type ? 'white' : 'transparent',
              backgroundColor: 'secondary.main',
              justifyContent: 'flex-start',
              px: 1,
              py: 0.5,
              width: '100%'
            }}
            onClick={() => {
              onClick(type);
            }}
          >
            {label}
          </ButtonBase>
        </Box>
      ))}
    </Box>
  );
};

export default ImageFormatSelection;
